import React from 'react';
import { Tooltip } from '@drone-js/core';

export const MAX_CHARTER_LENGTH_IN_TOOLTIP = 20;

export const getTruncatedText = (text: string) => {
    return text.length > MAX_CHARTER_LENGTH_IN_TOOLTIP ? `${text.slice(0, MAX_CHARTER_LENGTH_IN_TOOLTIP)}...` : text;
};

const FilterTooltipWrapper: React.FC<{ children: React.ReactNode; title: string }> = (props) => {
    const isOverflown = props.title.length > MAX_CHARTER_LENGTH_IN_TOOLTIP;

    if (!isOverflown) {
        return <>{props.children}</>;
    }

    return (
        <Tooltip data-testid="filters-tooltip" title={props.title}>
            {props.children}
        </Tooltip>
    );
};

FilterTooltipWrapper.displayName = 'FilterTooltipWrapper';

export default FilterTooltipWrapper;
